export default function Loader({ title = '' }) {
  return (
    <div className="flex flex-wrap justify-center w-full p-8">
      {title.length > 0 && (
        <div className="font-bold text-lg text-center mb-4 w-full">{title}</div>
      )}

      <img
        src={`${process.env.PUBLIC_URL}/images/loading.gif`}
        alt="loading"
        className="h-[64px] w-[64px]"
      />
    </div>
  );
}
